<template>
    <div class="row">
        <div class="mb-2 col-12">
            <div class="m-userStores__contactHeader">Adres:</div>
            {{ this.getShopAddress(data.address) }}
        </div>
        <div class="mb-2 col-12">
            <div class="m-userStores__contactHeader">Format:</div>
            {{ data.categories ? data.categories.join(', ') : '-' }}
        </div>
        <div class="mb-2 col-12">
            <div class="m-userStores__contactHeader">Powierzchnia sklepu:</div>
            {{ data.address.area || '-' }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: false
        }
    },
    methods: {
        getShopAddress(address) {
            const { street, postalCode, city, building, local } = address
            return `${street} ${building || ''}${
                local ? '/' + local : ''
            }, ${postalCode} ${city}`
        }
    }
}
</script>
